import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { NavLink } from 'react-router-dom';
import Badge from 'components/Badge/Badge';
import Tooltip from 'components/Tooltip/Tooltip';
import { routes } from 'constants/Application';
import classes from './SideNav.module.scss';

class SideNavItem extends React.PureComponent {
  UNSAFE_componentWillUpdate(nextProps) {
    if (this.props.routeLoaded === '/' && nextProps.routeLoaded !== '/' && this.props.markCallHistoryAsViewed) {
      this.props.markCallHistoryAsViewed();
    }
  }

  isActiveEvent = () => {
    if ([routes.contacts, routes.meetings, routes.roomSystems].includes(this.props.route)) {
      return this.props.routeLoaded && this.props.route === this.props.routeLoaded.substr(0, this.props.route.length);
    }
    return this.props.route === this.props.routeLoaded;
  };

  render() {
    const { badgeCount, route, routeLoaded } = this.props;
    const tooltip = this.props.wide ? null : (
      <Tooltip location="right" label={this.props.label} style={{ marginLeft: '-3px' }} />
    );

    if (route === '/chat' && !this.props.isChatEnabled) return null;

    let showBadge;
    if (route === '/') {
      showBadge = badgeCount && routeLoaded !== '/' && route === '/';
    } else {
      showBadge = badgeCount;
    }

    return (
      <li className={classes.menuItem}>
        {tooltip}
        {showBadge ? <Badge count={badgeCount} className={classes.badge} /> : null}
        <NavLink
          activeClassName={classes.active}
          className={classes.menuItemLink}
          data-testid={`${route === routeLoaded ? 'activeNav' : 'inactiveNav'}(${route})`}
          exact
          isActive={this.isActiveEvent}
          to={route}
        >
          <div className={classes.menuItemIcon}>{this.props.icon}</div>
          {this.props.wide ? (
            <div className={classes.menuItemLabel}>
              <p>{this.props.label}</p>
            </div>
          ) : null}
        </NavLink>
      </li>
    );
  }
}

SideNavItem.propTypes = {
  badgeCount: PT.number,
  icon: PT.element.isRequired,
  isChatEnabled: PT.bool,
  label: PT.object.isRequired,
  markCallHistoryAsViewed: PT.func,
  route: PT.string.isRequired,
  routeLoaded: PT.string,
  wide: PT.bool.isRequired
};

export default SideNavItem;
